/**
 * ОТЛОЖЕННЫЙ ЗАПУСК ТЯЖЁЛЫХ СТОРОННИХ ВИДЖЕТОВ.
 *
 * Зачем: чат-виджет Rocketdata (widget.js → omni.rocketdata.io) — это
 * ~28 запросов и ~2,4 МБ (Vue-приложение в iframe), которые раньше стартовали
 * сразу после гидрации и попадали в окно замера Lighthouse/CrUX: забивали
 * сеть и главный поток, когда страница ещё догружает картинки и чанки
 * (Lighthouse 06.10.2026: TTI 14,2 с, Speed Index 8,6 с).
 *
 * Как: колбэк выполняется ОДИН раз — по первому действию пользователя
 * (тач, клик, клавиша, скролл, движение мыши) или по таймауту после
 * события `load`, что наступит раньше. Человеку чат нужен не в первые
 * секунды; тот, кто сразу полез в интерфейс, получит виджет мгновенно —
 * загрузка начнётся по первому же касанию.
 *
 * requestIdleCallback не используем: в Safari 14.1 его нет (CLAUDE.md).
 */

const INTERACTION_EVENTS = [
  'pointerdown',
  'touchstart',
  'keydown',
  'scroll',
  'mousemove'
] as const;

export const loadWhenIdle = (
  callback: () => void,
  { timeoutAfterLoadMs = 15_000 }: { timeoutAfterLoadMs?: number } = {}
): (() => void) => {
  if (typeof window === 'undefined') {
    return () => {};
  }

  let done = false;
  let timer: number | undefined;

  const cleanup = (): void => {
    INTERACTION_EVENTS.forEach(type =>
      window.removeEventListener(type, run, true)
    );
    window.removeEventListener('load', armTimer);
    if (timer !== undefined) {
      window.clearTimeout(timer);
    }
  };

  function run(): void {
    if (done) {
      return;
    }
    done = true;
    cleanup();
    try {
      callback();
    } catch (e) {
      console.log('[loadWhenIdle]', e);
    }
  }

  function armTimer(): void {
    timer = window.setTimeout(run, timeoutAfterLoadMs);
  }

  INTERACTION_EVENTS.forEach(type =>
    window.addEventListener(type, run, { capture: true, passive: true, once: true })
  );

  if (document.readyState === 'complete') {
    armTimer();
  } else {
    window.addEventListener('load', armTimer, { once: true });
  }

  // отмена (размонтирование RootEffects) — виджет так и не грузим
  return () => {
    done = true;
    cleanup();
  };
};
